import React, { useState } from "react";
import useHeaderStore from "../../store/header";
import BranchSelector from "./BranchSelector";
import { useMetaContext } from "../../Router/MetaContext";
const SelectStore = () => {
  const { metadata, loadingImport } = useMetaContext();
  const { rootContext, setRootContext } = useHeaderStore()
  // STORE SERVICE
  const [selectedStoreList, setSelectedStoreList] = useState([]);
  const handleSelectAllStore = async () => {
    const allStores = data?.records || [];
    const storedCompanyIds = rootContext.allowed_company_ids || [];
    const newCompanyIds = allStores.map((item) => item.id);

    // Check if all new company ids are already stored
    const AllInContext = newCompanyIds.every((id) =>
      storedCompanyIds.includes(id)
    );

    if (AllInContext) {
      setRootContext({ allowed_company_ids: selectedStoreList.map((item) => item.id) })
    } else {
      setRootContext({ allowed_company_ids: newCompanyIds })
    }
  };

  return (
    <BranchSelector
      currentStore={metadata?.companies?.current_company_id}
      stores={metadata?.companies?.allowed_companies}
      onSelectAll={handleSelectAllStore}
    />
  );
};

export default SelectStore;
